import { useEffect, useState } from "react";
import "../Dashboard/Dashboard.css";
import { Link } from "react-router-dom";
import BackButton from "../Goback/GoBack";
import StudentTable from "../Dashboard/StudentTable";
import { useActivateExistingStudents } from "../../../../hooks/school/assing-license/useActivateExistingStudents";
import { useActivateStudents } from "../../../../hooks/school/assing-license/useActivateStudents";
import DeleteModal from "../../../common/DeleteModal";
import { Button } from "react-bootstrap";
import AssignTeacherModal from "./AssignTeacherModal";
import RoleGuard from "../../../auth/RoleGuard";

export const SchoolAdminStudent = ({ type = "studentPage" }) => {
  const {
    data: activateData,
    loading: activateCheckLoading,
    error: activateCheckError,
    getActivateExistingStudents,
  } = useActivateExistingStudents();

  const {
    loading: activating,
    error: activateError,
    success: activateSuccess,
    message: activateMessage,
    activateStudents,
  } = useActivateStudents();

  const [showActivateModal, setShowActivateModal] = useState(false);
  const [selectedStudentIds, setSelectedStudentIds] = useState(new Set());
  const [showAssignTeacherModal, setShowAssignTeacherModal] = useState(false);
  // Key to force-remount StudentTable after successful assign (to refresh data + clear selection)
  const [tableKey, setTableKey] = useState(0);

  const canActivate = activateData?.can_activate > 0;

  useEffect(() => {
    getActivateExistingStudents();
  }, []);

  const handleActivateClick = () => {
    setShowActivateModal(true);
  };

  const handleActivateClose = () => {
    setShowActivateModal(false);
  };

  const handleActivateConfirm = async () => {
    await activateStudents(() => {
      getActivateExistingStudents();
    });
  };

  const handleAssignTeacherSuccess = () => {
    // Reset selection and refresh table
    setSelectedStudentIds(new Set());
    setTableKey((k) => k + 1);
  };

  return (
    <>
      <div className="dashboardBody">
        <div className="container-fluid p-0">
          <div className="p-0" id="mainContent">
            <div className="mb-4">
              <section>
                <div className="container-fluid">
                  <div className="row mb-4 align-items-center">
                    {type != "dashboard" && (
                      <>
                        <div className="col-12 col-md-12">
                          <BackButton />
                        </div>
                        <div className="col-12 col-md-4 my-2">
                          <p className="tchrdashboard-cmntitl mb-0">
                            All Students
                          </p>
                        </div>
                      </>
                    )}

                    <div
                      className={`${type === "dashboard" ? "col-12 col-md-12" : "col-12 col-md-8"} text-md-end my-2 d-flex justify-content-end gap-2`}
                    >
                      <RoleGuard permission="dashboard_assign_teachers">
                        <Button
                          className="dashboard-btn"
                          disabled={selectedStudentIds.size === 0}
                          onClick={() => setShowAssignTeacherModal(true)}
                        >
                          Assign Teacher
                          {selectedStudentIds.size > 0
                            ? ` (${selectedStudentIds.size})`
                            : ""}
                        </Button>
                      </RoleGuard>

                      <RoleGuard permission="dashboard_assign_licenses">
                        <Button
                          className="dashboard-btn"
                          disabled={activateCheckLoading || !canActivate}
                          onClick={handleActivateClick}
                          title={
                            activateCheckLoading
                              ? "Checking..."
                              : canActivate
                                ? `Activate ${activateData.can_activate} student(s)`
                                : activateCheckError
                                  ? "Failed to check activation status"
                                  : "No students available to activate"
                          }
                        >
                          {activateCheckLoading
                            ? "Checking..."
                            : `Assign Licenses${canActivate ? ` (${activateData.can_activate})` : ""}`}
                        </Button>
                      </RoleGuard>

                      <RoleGuard permission="dashboard_add_student">
                        {type != "dashboard" && (
                          <Link
                            to="/school-admin/students/create"
                            className="dashboard-btn"
                          >
                            Add Student
                          </Link>
                        )}
                      </RoleGuard>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12">
                      <StudentTable
                        RoleGuard={RoleGuard}
                        key={tableKey}
                        onSelectionChange={setSelectedStudentIds}
                      />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>

      <DeleteModal
        showModal={showActivateModal}
        handleClose={handleActivateClose}
        handleDelete={handleActivateConfirm}
        message={`Are you sure you want to activate ${activateData?.can_activate || 0} student(s)? This will assign available licenses to inactive students.`}
        loading={activating}
        error={activateError}
        success={activateSuccess}
        successMessage={activateMessage || "Students activated successfully."}
        onSuccessContinue={handleActivateClose}
        customSuccessTitle="Activation Successful"
        customErrorTitle="Activation Failed"
        customConfirmTitle="Confirm Activation"
        customActionButtonText="Activate"
        customLoadingButtonText="Activating..."
      />

      <AssignTeacherModal
        show={showAssignTeacherModal}
        handleClose={() => setShowAssignTeacherModal(false)}
        selectedStudentIds={selectedStudentIds}
        onSuccess={handleAssignTeacherSuccess}
      />
    </>
  );
};
